/**
 * Get Domain Handler
 * 
 * CQRS Query Handler that delegates to DomainQueryService.
 * Thin adapter layer for read operations.
 * 
 * FIXED: No more Inversify - direct constructor injection following party-manager pattern.
 */

import { IQueryHandler } from '@swoft/core';
import { GetDomainQuery, DomainDto } from '../queries/GetDomainQuery';
import { DomainCQRSQueryService } from '../services/DomainQueryService';

export class GetDomainHandler implements IQueryHandler<GetDomainQuery, DomainDto | null> {
  constructor(
    private readonly domainQueryService: DomainCQRSQueryService
  ) {}

  async handle(query: GetDomainQuery): Promise<DomainDto | null> {
    const domainDto = await this.domainQueryService.getDomain(query.domainId);
    
    if (!domainDto) {
      throw new Error(`Domain with ID ${query.domainId} not found`);
    }

    return domainDto;
  }
}